import { z } from 'zod';
import { nullableUuidString } from '../zod-helpers/index.js';
import { DELIVERY_ASSIGNEE_FIELDS, DELIVERY_ASSIGNEE_REQUIRED_MESSAGE, deliveryAssigneeMismatchMessage, deliveryAssigneeRequiredField, } from './delivery-assignee/index.js';
import { deliveryDriverUserIdSchema, deliveryTypeIdSchema, manifestNumberSchema, } from './delivery-fields/index.js';
import { plannedShipDateSchema } from './ship-date-input.js';
// `.strict()`: an unknown key is an error, not a silent strip; the type decides which assignee applies.
export const scheduleSalesOrderDeliveryInputSchema = z
    .object({
    deliveryTypeId: deliveryTypeIdSchema,
    carrierId: nullableUuidString('Invalid carrier selection.').optional(),
    carrierServiceId: nullableUuidString('Invalid carrier service selection.').optional(),
    deliveryDriverUserId: deliveryDriverUserIdSchema.optional(),
    shipDate: plannedShipDateSchema,
    manifestNumber: manifestNumberSchema,
})
    .strict()
    .superRefine((input, context) => {
    const requiredField = deliveryAssigneeRequiredField(input.deliveryTypeId);
    if (requiredField && !input[requiredField]) {
        context.addIssue({
            code: 'custom',
            message: DELIVERY_ASSIGNEE_REQUIRED_MESSAGE,
            path: [requiredField],
        });
    }
    for (const field of DELIVERY_ASSIGNEE_FIELDS) {
        const message = input[field]
            ? deliveryAssigneeMismatchMessage(input.deliveryTypeId, field)
            : null;
        if (message)
            context.addIssue({ code: 'custom', message, path: [field] });
    }
});
//# sourceMappingURL=schedule-delivery-input.js.map